export default __webpack_public_path__ + "static/media/Marte.6cae79d3.png";